import axios from "axios";
import { handleRequest } from "./http-utils";

interface VerbParamsInterface {
  url: string;
  body?: any;
  config?: any;
}

const Get = async ({ url, config = {} }: VerbParamsInterface) => {
  return handleRequest(axios.get, url, config);
};

const Post = async ({ url, body = {}, config = {} }: VerbParamsInterface) => {
  return handleRequest(axios.post, url, config, body);
};

const Put = async ({ url, body = {}, config = {} }: VerbParamsInterface) => {
  return handleRequest(axios.put, url, config, body);
};

const Patch = async ({ url, body = {}, config = {} }: VerbParamsInterface) => {
  return handleRequest(axios.patch, url, config, body);
};

const Del = async ({ url, config = {} }: VerbParamsInterface) => {
  return handleRequest(axios.delete, url, config);
};

const actions = {
  Get,
  Post,
  Put,
  Del,
  Patch,
};

export default actions;
